export default __webpack_public_path__ + "820d4cf6562d35dd357265e046d119cf.png";